export { default } from './Typography';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/esm/Typography/index.js
// module id = 25
// module chunks = 0